import { lazy, Suspense } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

import { GuestGuard } from 'src/auth/guard';
import AuthClassicLayout from 'src/layouts/auth/classic';

import { SplashScreen } from 'src/components/loading-screen';
import AuthSetPasswordClassicLayout from 'src/layouts/auth/set-password-classic';

// ----------------------------------------------------------------------

// JWT
const JwtLoginPage = lazy(() => import('src/pages/auth/jwt/login'));
const JwtRegisterPage = lazy(() => import('src/pages/auth/jwt/register'));
const JwtResetPasswordPage = lazy(() => import('src/pages/auth/jwt/reset-passsword'));
const JwtForgotPasswordPage = lazy(()=>import('src/pages/auth/jwt/forgot-password'));
const RegistrationEmailVerificationPage = lazy(() => import('src/pages/auth/jwt/verify-registration-email'));
// ----------------------------------------------------------------------

const authJwt = {
  path: 'jwt',
  element: (
    <Suspense fallback={<SplashScreen />}>
      <Outlet />
    </Suspense>
  ),
  children: [
    {
      path: 'login',
      element: (
        <GuestGuard>
          <AuthClassicLayout>
            <JwtLoginPage />
          </AuthClassicLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'register',
      element: (
        <GuestGuard>
          <AuthClassicLayout title="Manage the job more effectively with TechStack">
            <JwtRegisterPage />
          </AuthClassicLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'set-password/:accessToken',
      element: (
        <GuestGuard>
          <AuthSetPasswordClassicLayout title="Finish creating your account by setting your password">
            <JwtResetPasswordPage />
          </AuthSetPasswordClassicLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'forgot-password',
      element: (
        <GuestGuard>
          <AuthSetPasswordClassicLayout title="Secure Your Account with Your New Password">
            <JwtForgotPasswordPage />
          </AuthSetPasswordClassicLayout>
        </GuestGuard>
      ),
    },
    {
      path: 'verify-email',
      element: (
        <GuestGuard>
          <RegistrationEmailVerificationPage/>
        </GuestGuard>
      ),
    },
  ],
};

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    children: [authJwt],
  },
];
